<template>
  <b-modal
    id="detailsModal"
    size="xl"
    content-class="sub-menu-bg-blue-transparent gtp-details-modal"
    title="Ground Truth Point Details"
    hide-footer
   
    scrollable
    @shown="renderMap"
  >
    <div class="col-lg-12">
      <div>
        <div id="mapGTP" class="ol-map mapGTP"></div>
      </div>
      <vue-bootstrap4-table
        :rows="gtpDetailsRows"
        :columns="gtpDetailsColumns"
        :config="detailsConfig"
        :classes="classes"
      ></vue-bootstrap4-table>
    </div>
  </b-modal>
</template>

<style>
.mapGTP {
  height: 500px !important;
}
.gtp-details-modal .menu-bg-blue-transparent,
.gtp-details-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.gtp-details-modal table { color: #063c6d !important; text-shadow: none !important; }
.gtp-details-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.gtp-details-modal thead th a,
.gtp-details-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.gtp-details-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.gtp-details-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.gtp-details-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.gtp-details-modal .footer-pagination-row td,
.gtp-details-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
</style>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import {fromLonLat, transform} from 'ol/proj'
import Map from 'ol/Map'
import OSM from 'ol/source/OSM'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'

export default {
  name: 'MMP_GTP_Tracking_DetailsModal',
  components: {
    VueBootstrap4Table
  },
  props: ['gtpDetailsRows', 'lat', 'long'],
  data() {
    return {
      detailsConfig: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        pagination: false,
        pagination_info: false,
        selected_rows_info: false,
        global_search: {
          placeholder: 'Search...',
          visibility: false,
          showClearButton: false,
          searchOnPressEnter: false
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        show_refresh_button: false,
        show_reset_button: false
      },
      gtpDetailsColumns: [
        {
          label: 'Survey Id',
          name: 'id',
          sort: false
        },

        {
          label: 'GTP ID',
          name: 'gtp_id',
          sort: false
        },
        {
          label: 'Name',
          name: 'name',
          sort: false
        },
        {
          label: 'Subcountry',
          name: 'subcountry',
          sort: false
        },
        {
          label: 'Date Collected',
          name: 'date_collected',
          sort: false
        },
        {
          label: 'Antenna',
          name: 'antenna',
          sort: false
        },
        {
          label: 'Useable',
          name: 'useable',
          sort: false
        },
        {
          label: 'Active',
          name: 'active',
          sort: false
        },
        {
          label: 'Deprecated Date',
          name: 'deprecated_date',
          sort: false
        },
        {
          label: 'Comments',
          name: 'comments',
          sort: false
        },
        {
          label: 'FTP Path',
          name: 'ftp_path',
          sort: false
        },
        {
          label: 'Lat, Long',
          name: 'lat_long',
          sort: false
        }
      ],
      mapGTP: null,
      vectorSource: null,
      classes: {
        table: {
          'menu-bg-blue-transparent': true
        }
      }
    }
  },
  methods: {
    initVectorLayer() {
      this.vectorSource = new VectorSource({})
      let vectorLayer = new VectorLayer({
        source: this.vectorSource
      })
      vectorLayer.setZIndex(999999999)
      this.mapGTP.addLayer(vectorLayer)
    },
    renderMap() {
      this.mapGTP = new Map({
        layers: [
          new TileLayer({
            source: new OSM(),
            name: 'OSM base layer',
            zIndex: 2
          })
        ],
        target: 'mapGTP',
        view: new View({
          center: new transform(
            [this.long, this.lat],
            'EPSG:4326',
            'EPSG:3857'
          ),
          zoom: 17
        })
      })
      this.showOnMap()
    },
    showOnMap() {
      this.initVectorLayer()
      let geoMarker = new Feature({
        type: 'geoMarker',
        geometry: new Point(new fromLonLat([this.long, this.lat]))
      })
      this.vectorSource.addFeature(geoMarker)
    }
  }
}
</script>
